module.exports = __webpack_public_path__ + "img/10m-sprint.5b7b4ced.png";